export default "__VITE_ASSET__fd33e2d2__"